<template>
    <div class="enps-rating-distribution" :title="tooltip">
        <span
            v-for="value in values"
            :key="value"
            class="enps-rating-distribution__segment"
            :style="{ width: widthPercent(value) + '%', backgroundColor: colors[value] }"
        ></span>
    </div>
</template>
<script>
// pt.3: компактная горизонтальная полоска в строке таблицы рейтинга — сегменты 5..1
// пропорциональны количеству оценок, сумма сегментов равна ratingsCount строки. Не canvas,
// не отдельный график — просто ячейка, div'ы шириной в проценты.
const RATING_COLORS = {
    5: '#00a55a',
    4: '#8bc34a',
    3: '#ffc107',
    2: '#ff9800',
    1: '#f44336',
};

export default {
    props: {
        distribution: {
            type: Object,
            default: () => ({ 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 }),
        },
    },
    data() {
        return {
            values: [5, 4, 3, 2, 1],
            colors: RATING_COLORS,
        };
    },
    computed: {
        total() {
            return this.values.reduce((sum, value) => sum + (this.distribution[value] || 0), 0);
        },
        tooltip() {
            return this.values.map((value) => `${value}: ${this.distribution[value] || 0}`).join(', ');
        },
    },
    methods: {
        widthPercent(value) {
            if (this.total === 0) {
                return 0;
            }

            return ((this.distribution[value] || 0) / this.total) * 100;
        },
    },
};
</script>
<style lang="scss">
.enps-rating-distribution {
    display: flex;
    width: 100px;
    height: 10px;
    overflow: hidden;
    border-radius: 4px;
    background-color: #f0f0f0;

    &__segment {
        height: 100%;
    }
}
</style>
